<template>
  <div>
    <div class="inner">
      <div class="header">
        <img
          :class="{
          points:true,
          shrink: !expandPoints}"
          src="../../assets/points.png"
        />
        <img @click="goBack" src="../../assets/close.svg" />
      </div>
      <div style="z-index:2;position:relative">
        <p>
          Utilizza i punti guadagnati
          per meravigliosi premi e
          offerte speciali
        </p>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: "HeaderPunti",
  methods: {
    goBack() {
      this.expandPoints = false;
      window.setTimeout(() => {
        this.$router.go(-1);
      }, 180);
    }
  },
  data() {
    return {
      expandPoints: true
    };
  }
};
</script>


<style lang="less" scoped>
.bg {
  width: 100%;
  position: absolute;
  left: 0;
  bottom: 0;
}
h2 {
  margin-bottom: 20px;
}
@keyframes userimage {
  from {
    transform: scale(0.5) translate(250%, 0%);
  }
  to {
    transform: scale(1) translate(0%, 0%);
  }
}

@keyframes userimager {
  from {
    transform: scale(1) translate(0%, 0%);
  }
  to {
    transform: scale(0.5) translate(250%, 0%);
  }
}
.points {
  z-index: 10;
  animation: userimage 300ms linear;

  width: 50%;
}
.points.shrink {
  z-index: 10;
  animation: userimager 200ms linear forwards;
}

p {
  line-height: 1.3em;
  font-size: 1em;
  margin: 0;
  color: #7a7978;

  text-align: left;
  margin-top: -20px;
  margin-left: 30px;
  margin-right: 80px;
  margin-bottom: 20px;
}
</style>